import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';

export default class CategoryPageTracker {
  constructor(options) {
    this.$element = $(options.element);
    this.name = this.$element.data("name");
    this.uuid = this.generateId();
  }

  init() {
    this.recommender = this.$element.find("[data-video-id]").filter("[data-recommender]").data("recommender");
    this.addUuidToDom();
    this.bindAhoyEventHeaderClick();
    this.sendImpression();
    // else do not send impression here, may be part of experiment variant which is not selected

    this.bindAhoyEventClick();
  }

  sendImpression() {
    AhoyEvent.send("CATEGORY::SECTION::GET", this.generateProperties());
  }

  hasBeenShown(maximumYOffset) {
    var offsetTop = this.$element.offset().top;
    var maximumWindowBottomOffset = maximumYOffset + window.innerHeight;
    return maximumWindowBottomOffset > offsetTop;
  }

  getItems() {
     var video_items = this.$element.find("[data-video-id]");
     var items = [];
     video_items.each(function (index, object) {
       var itemProperties = {
         video_id: $(object).data("video-id"),
         position: $(object).data("position"),
       };
       var recommender = $(object).data("recommender");
       if (recommender) {
         itemProperties.recommender = recommender;
       }
       var recommendationType = $(object).data("item-type");
       if (recommendationType) {
         itemProperties.recommendation_type = recommendationType;
       }
       items.push(itemProperties);
     });
     return items;
  }

  bindAhoyEventHeaderClick() {
    this.$element.find("[data-event='ctr_head_tracker']").on("click", () => {
      this.sendHeaderConversion("title");
    });

    this.$element.find("[data-event='ctr_see_all_tracker']").on("click", () => {
      this.sendHeaderConversion("see_all");
    });
  }

  bindAhoyEventClick(){
    this.$element.find("[data-event='ctr_tracker']").on("click", (e) => {
      var widget = $(e.currentTarget).closest("[data-video-id]");
      var uuid = $(e.currentTarget).closest('[data-uuid]').data('uuid');
      var videoId = widget.data("video-id");
      var position = widget.data("position");
      var recommender = widget.data("recommender");
      var recommendationType = widget.data("item-type");


      this.sendConversion(videoId, position, uuid, recommender, recommendationType);
    });
  }

  sendConversion(videoId, position, uuid, recommender, recommendationType){
    var properties = {
      platform: VidioHelpers.getPlatform(),
      section: 'popular_videos',
      app_name: "vidio",
      video_id: videoId,
      position: position,
      uuid: uuid,
      page_name: 'category-' + this.name.replace('popular_videos_', ''),
      recommender: recommender,
      recommendation_type: recommendationType
    };
    AhoyEvent.send("CATEGORY::SECTION::CLICK", properties);
  }

  sendHeaderConversion(clickable) {
    var properties = {
      platform: VidioHelpers.getPlatform(),
      section: 'popular_videos',
      app_name: "vidio",
      clickable: clickable,
      page_name: 'category-' + this.name.replace('popular_videos_', ''),
      recommender: this.recommender
    };
    AhoyEvent.send("CATEGORY::SECTION::HEADER", properties);
  }

  generateProperties(){
    var properties = {
      uuid: this.uuid,
      platform: VidioHelpers.getPlatform() ,
      section: 'popular_videos',
      app_name: "vidio",
      items: this.getItems(),
      page_name: 'category-' + this.name.replace('popular_videos_', ''),
      recommender: this.recommender
    };

    return properties;
  }

  // http://stackoverflow.com/a/8809472
  generateId() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
  }

  addUuidToDom(){
    this.$element.attr('data-uuid', this.uuid);
  }

}
